module.exports = __webpack_public_path__ + "static/img/h5-7.2709a4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h5-7.png
// module id = i7jD
// module chunks = 1